import React from "react"
import PropTypes from "prop-types"


const importImages = (r) => {
  const images = {}
  r.keys().map((item,) => { images[item.replace("./", "")] = r(item).default })
  return images
}
  
const logos = importImages(require.context("../assets/cohorts/", false, /\.(png|jpe?g|svg)$/)) // eslint-disable-line no-undef

const CohortLogo = ({ cohort, ...props }) => {

  const logo = logos[`${cohort.name}.png`]

  return logo ? <img
    {...props}
    src={logo}
    alt={cohort.name}
  /> : <></>
}

CohortLogo.propTypes = { cohort: PropTypes.object.isRequired, }

CohortLogo.defaultProps = {}

export default CohortLogo